import React from 'react';
import { Document, Page, View, Text, Image, StyleSheet, Font, Svg, Polygon, Rect } from '@react-pdf/renderer';
import moment from 'moment/moment';
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';
import SFRegular from '../../assets/font/SF-Pro-Display-Regular.ttf';
import SFMedium from '../../assets/font/SF-Pro-Display-Medium.ttf';
import SFSemibold from '../../assets/font/SF-Pro-Display-Bold.ttf';
import NSLight from '../../assets/font/NotoSansSC-Light.ttf';
import NSRegular from '../../assets/font/NotoSansSC-Regular.ttf';
import NSMedium from '../../assets/font/NotoSansSC-Medium.ttf';
import NSSemibold from '../../assets/font/NotoSansSC-SemiBold.ttf';
import NSBold from '../../assets/font/NotoSansSC-Bold.ttf';

// Register fonts
Font.register({
  family: 'SF-Regular',
  src: SFRegular,
});
Font.register({
  family: 'SF-Medium',
  src: SFMedium,
});
Font.register({
  family: 'SF-Semibold',
  src: SFSemibold,
});
Font.register({
  family: 'NS-Light',
  src: NSLight,
});
Font.register({
  family: 'NS-Regular',
  src: NSRegular,
});
Font.register({
  family: 'NS-Medium',
  src: NSMedium,
});
Font.register({
  family: 'NS-Semibold',
  src: NSSemibold,
});
Font.register({
  family: 'NS-Bold',
  src: NSBold,
});

const isEmptyString = (value) => value != null && String(value).trim().length !== 0;

const Modern_template_2_pdf = ({
  document_number,
  business_detail,
  document_issue_date,
  document_due_date,
  client_detail,
  items,
  discount,
  discount_type,
  tax_amount,
  tax_label,
  document_note,
  template,
  document_currency,
  document_type,
  localization,
  signature_name,
  signature
}) => {
  const business_detaill = JSON.parse(business_detail) || {};
  const itemss = JSON.parse(items) || [];
  const client_detaill = JSON.parse(client_detail) || {};
  const document_currencyy = JSON.parse(document_currency) || {};
  const templatee = JSON.parse(template) || {};
  const localizationn =
    localization === 'zh' ? zh :
    localization === 'de' ? de :
    localization === 'en' ? en :
    localization === 'es' ? es :
    localization === 'fr' ? fr :
    localization === 'it' ? it :
    localization === 'pt' ? pt : en;

  const styles = StyleSheet.create({
    page: { backgroundColor: templatee?.selectedcolor?.primary },
    header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10, paddingHorizontal:20 },
    businessInfo: { width:'40%', alignItems: 'flex-end' },
    businessName: { fontSize: 22, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.tableheadercolor, marginBottom: 5 },
    businessText: { fontSize: 10, marginVertical:1, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor2 },
    logo: { width: 100, height: 100 },
    sectionTitle: { fontSize: 14, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.textcolor, marginTop: 20, marginBottom: 5 },
    clientRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10, paddingHorizontal:20 },
    clientColumn: { flex: 1 },
    metaRow: { marginVertical:1 ,flexDirection: 'row', justifyContent: 'space-between' },
    metaLabel: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.tableheadercolor },
    metaValue: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.tableheadercolor },
    tableHeader: { flexDirection: 'row', marginHorizontal:20 },
    tableHeaderText: { fontSize: 12, borderRadius:3, paddingVertical:7, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', backgroundColor: templatee?.selectedcolor?.secondary, color: templatee?.selectedcolor?.tableheadercolor },
    tableRow: { flexDirection: 'row', marginHorizontal:20, paddingVertical: 5, borderBottomWidth:1, borderBottomColor:templatee?.selectedcolor?.bordercolor },
    tableCell: { flex: 1, fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor },
    tableCellCenter: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor, textAlign: 'center' },
    tableCellRight: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor, textAlign: 'right' },
    totalsRow: { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 20, paddingVertical: 5 },
    totalsLabel: { fontSize: 10, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', color: templatee?.selectedcolor?.textcolor },
    totalsValue: { fontSize: 10, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', color: templatee?.selectedcolor?.textcolor, textAlign: 'right' },
    signature: { marginTop: 10, transform: 'scale(0.8)' },
    signatureName: { fontSize: 9, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.textcolor, textAlign: 'center' }
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* TOP HEADER REPLACEMENT */}
        <View style={{ width: '100%', height: 40 }}>
          <Svg width="100%" height="100%">
            {/* 1. Background Base (Primary Color) */}
            <Rect x="0" y="0" width="100%" height="100%" fill={templatee?.selectedcolor?.primary} />
            
            {/* 2. The "Skewed" Shape (Simulating skewX: 20deg) 
                The logic: To look skewed, the top right x and bottom right x need to be different.
            */}
            <Polygon 
                points="0,0 300,0 280,40 0,40" 
                fill={templatee?.selectedcolor?.third} 
            />
            
            {/* 3. The Secondary Color part */}
             <Polygon 
                points="200,0 600,0 580,180 225,40" 
                fill={templatee?.selectedcolor?.secondary} 
            />
          </Svg>
        </View>

        {/* CONTENT SPACER */}
        <View style={{ height: 50 }} />

        {/* BOTTOM FOOTER REPLACEMENT */}
        <View style={{ position: 'absolute', bottom: 0, width: '100%', height: 40 }}>
           <Svg width="100%" height="100%">
             {/* Background */}
            <Rect x="0" y="0" width="100%" height="100%" fill={templatee?.selectedcolor?.primary} />
            
            {/* Simulating skewX: -20deg (Slanting the other way) */}
            <Polygon 
               points="280,0 610,0 600,40 300,40" 
               fill={templatee?.selectedcolor?.secondary} 
           />
            <Polygon 
                points="0,0 395,0 375,40 0,40" 
                fill={templatee?.selectedcolor?.third} 
            />
          </Svg>
        </View>

        {/* Header */}
        <View style={styles.header}>
            <View style={{width:'60%'}}>
                {business_detaill?.business_logo && <Image src={{
                    uri: business_detaill.business_logo,
                    method: 'GET',
                    headers: {
                      'Cache-Control': 'no-cache, no-store, must-revalidate',
                      'Pragma': 'no-cache',
                      'Expires': '0',
                    },
                    body: null
                  }}  style={styles.logo} />}
            </View>
            <View style={styles.businessInfo}>
                <View style={{padding:8, borderRadius:4 ,backgroundColor:templatee?.selectedcolor?.secondary}}>
                    <Text style={styles.businessName}>{document_type === 'estimate' ? localizationn?.estimate_full_capital : localizationn?.invoice_full_capital}</Text>
                    <View style={{width:'100%'}}>
                        <View style={styles.metaRow}>
                            <Text style={styles.metaLabel}>{document_type === 'estimate' ? localizationn?.estimate_no : localizationn?.invoice_no}</Text>
                            <Text style={styles.metaValue}> {document_number}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
        {/* Client Info */}
        <View style={[styles.clientRow,{marginBottom:0}]}>
          <View style={styles.clientColumn}>
            <Text style={[styles.sectionTitle,{marginBottom:0}]}>{localizationn?.from}</Text>
          </View>
          <View style={styles.clientColumn}>
            <Text style={[styles.sectionTitle,{marginBottom:0}]}>{localizationn?.bill_to}</Text>
          </View>
          <View style={styles.clientColumn}>
            
          </View>
        </View>
        <View style={styles.clientRow}>
          <View style={styles.clientColumn}>
            <Text style={[styles.businessText,{fontSize:12, fontFamily:localization=="zh"?'NS-Medium':'SF-Medium'}]}>{business_detaill?.business_name}</Text>
            {isEmptyString(business_detaill?.business_street_1) && <Text style={styles.businessText}>{business_detaill?.business_street_1}</Text>}
            {isEmptyString(business_detaill?.business_phone_1) && <Text style={styles.businessText}>{business_detaill?.business_phone_1}</Text>}
            {isEmptyString(business_detaill?.business_phone_2) && <Text style={styles.businessText}>{business_detaill?.business_phone_2}</Text>}
            {isEmptyString(business_detaill?.business_country) && <Text style={styles.businessText}>{business_detaill?.business_country}</Text>}
            {isEmptyString(business_detaill?.business_city) && <Text style={styles.businessText}>{business_detaill?.business_city}</Text>}
            {isEmptyString(business_detaill?.business_email) && <Text style={styles.businessText}>{business_detaill?.business_email}</Text>}
          </View>
          <View style={styles.clientColumn}>
            {isEmptyString(client_detaill?.client_name) && <Text style={styles.businessText}>{client_detaill?.client_name}</Text>}
            {isEmptyString(client_detaill?.client_address_1) && <Text style={styles.businessText}>{client_detaill?.client_address_1}</Text>}
            {isEmptyString(client_detaill?.client_phone) && <Text style={styles.businessText}>{client_detaill?.client_phone}</Text>}
            {isEmptyString(client_detaill?.client_mobile) && <Text style={styles.businessText}>{client_detaill?.client_mobile}</Text>}
            {isEmptyString(client_detaill?.client_country) && <Text style={styles.businessText}>{client_detaill?.client_country}</Text>}
            {isEmptyString(client_detaill?.client_city) && <Text style={styles.businessText}>{client_detaill?.client_city} {client_detaill?.client_zip}</Text>}
            {isEmptyString(client_detaill?.client_email) && <Text style={styles.businessText}>{client_detaill?.client_email}</Text>}
          </View>
          <View style={[styles.clientColumn,{justifyContent:'flex-end' ,alignItems:'flex-end'}]}>
            <View style={{flexDirection:'row'}}>
                <Text style={[styles.businessText,{color:templatee?.selectedcolor?.textcolor2}]}>{localizationn?.issued}:</Text>
                <Text style={[styles.businessText,{color:templatee?.selectedcolor?.textcolor}]}>&nbsp;{moment(document_issue_date).format('MMM,DD,YYYY')}</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={[styles.businessText,{color:templatee?.selectedcolor?.textcolor2}]}>{document_type === 'estimate' ? localizationn?.valid_until : localizationn?.due_date}</Text>
                <Text style={[styles.businessText,{color:templatee?.selectedcolor?.textcolor}]}>&nbsp;{moment(document_due_date).isValid() ? moment(document_due_date).format("MMM,DD,YYYY") : 
                    document_due_date=="On Receipt"?localizationn?.on_receipt:
                    document_due_date=="3 days"?localizationn?.three_days:
                    document_due_date=="10 days"?localizationn?.ten_days:
                    document_due_date=="30 days"?localizationn?.thirty_days:
                    document_due_date=="No Valid Date"?localizationn?.no_valid_date:
                    document_due_date=="No Duo Date"?localizationn?.no_duo_date:
                    document_due_date
                }</Text>
            </View>
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={[styles.tableHeaderText,{width:'30%', textAlign:'center', marginLeft:-2}]}>{localizationn?.description}</Text>
          <Text style={[styles.tableHeaderText,{width:'30%',textAlign:'center', marginHorizontal:2}]}>{localizationn?.quantity_up}</Text>
          <Text style={[styles.tableHeaderText,{width:'20%',textAlign:'center', marginRight:2}]}>{localizationn?.unit_price}</Text>
          <Text style={[styles.tableHeaderText,{width:'20%',textAlign:'center'}]}>{localizationn?.total}</Text>
        </View>

        {/* Table Rows */}
        {itemss.map((item, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={[styles.tableCellCenter,{width:'30%'}]}>{item.item_name}</Text>
            <Text style={[styles.tableCellCenter,{width:'30%'}]}>{numberbeautify(item.item_quantity)}{item.item_type === 'service' ? `/${item.item_unit_type}` : ''}</Text>
            <Text style={[styles.tableCellCenter,{width:'20%'}]}>{document_currencyy?.symbol}{numberbeautify(item.item_price)}</Text>
            <Text style={[styles.tableCellCenter,{width:'20%'}]}>{document_currencyy?.symbol}{numberbeautify(money_rounding(Number(item.item_price) * Number(item.item_quantity)))}</Text>
          </View>
        ))}

        {/* Totals */}
        <View style={{ marginTop: 10, flexDirection:'row', justifyContent:'space-between' }}>
          <View style={{ width:'50%'}}>
            {isEmptyString(document_note) && (
              <Text>{document_note}</Text>
            )}
          </View>
          <View style={{ width:'50%'}}>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{localizationn?.sub_total}</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}{
                numberbeautify(
                  money_rounding(
                    itemss?.reduce((total, item) => total + (Number(item.item_price) * Number(item.item_quantity)), 0)
                  )
                )
              }</Text>
            </View>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{localizationn?.discount}: {discount} {discount_type == 'percent' ? '%' : document_currencyy?.symbol}</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}
                {discount_type=='percent'?
                  numberbeautify(money_rounding(itemss?.reduce((total, item) => Number(total) + ((Number(item.item_price) * Number(item.item_quantity) * (Number(discount) / 100))),0))):
                  numberbeautify(money_rounding(discount))
                }</Text>
            </View>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{tax_label}: {tax_amount}%</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}
                                            {(() => {
                                              const items = itemss || [];
                                              const discountType = discount_type;
                                              const discountValue = Number(discount) || 0;
                                              // Calculate total of all items
                                              const totalAmount = items.reduce(
                                                (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                                0
                                              );
                                              // Calculate discount
                                              const discountAmount = discountType === 'percent'
                                                ? (totalAmount * discountValue / 100)
                                                : discountValue;
                                              // Calculate the total after discount
                                              const totalAfterDiscount = totalAmount - discountAmount;
                                              // Calculate the proportion of discount for each item
                                              const discountRatio = totalAmount > 0 ? discountAmount / totalAmount : 0;
                                              // Calculate tax only on taxable items after proportional discount
                                              const taxableAmount = items.reduce(
                                                (total, item) => {
                                                  if (item.item_tax_state) {
                                                    const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                                    const itemDiscount = itemTotal * discountRatio;
                                                    return total + (itemTotal - itemDiscount);
                                                  }
                                                  return total;
                                                },
                                                0
                                              );
                                              const taxTotal = taxableAmount * (Number(tax_amount) / 100);
                                              return numberbeautify(money_rounding(taxTotal));
                                            })()}</Text>
            </View>
            <View style={[styles.totalsRow,{backgroundColor:templatee?.selectedcolor?.secondary}]}>
              <Text style={[styles.totalsLabel,{color:templatee?.selectedcolor?.tableheadercolor}]}>{localizationn?.total}</Text>
              <Text style={[styles.totalsValue,{color:templatee?.selectedcolor?.tableheadercolor}]}>{document_currencyy?.symbol}
                                            {(() => {
                                              const items = itemss || [];
                                              const discountType = discount_type;
                                              const discountValue = Number(discount) || 0;
                                              // Calculate subtotal
                                              const subtotal = items.reduce(
                                                (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                                0
                                              );
                                              // Apply discount to subtotal
                                              const discountt = discountType === 'percent'
                                                ? (subtotal * discountValue / 100)
                                                : discountValue;
                                              const subtotalAfterDiscount = subtotal - discountt;
                                              // Calculate how much of the discounted subtotal is taxable
                                              const taxableRatio = subtotal > 0 ? subtotalAfterDiscount / subtotal : 0;
                                              // Calculate tax only on taxable items after proportional discount
                                              const taxTotal = items.reduce(
                                                (total, item) => {
                                                  if (item.item_tax_state) {
                                                    const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                                    const itemAfterDiscount = itemTotal * taxableRatio;
                                                    return total + (itemAfterDiscount * (Number(tax_amount) / 100));
                                                  }
                                                  return total;
                                                },
                                                0
                                              );
                                              const totalAfterDiscount = subtotalAfterDiscount + taxTotal;
                                              return numberbeautify(money_rounding(totalAfterDiscount));
                                            })()}</Text>
            </View>
          </View>
        </View>

        {/* Signature */}
        {signature && (
          <View style={{ width:'100%',flexDirection:'row', marginTop: 10 }}>
            <View style={{width:'50%',height:'100%'}} />
            <View style={{width:'50%',alignItems:'center'}}>
              <Image src={{
                  uri: signature,
                  method: 'GET',
                  headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                  },
                  body: null
                }} style={styles.signature} />
              <Text style={styles.signatureName}>{signature_name}</Text>
            </View>
          </View>
        )}
      </Page>
    </Document>
  );
};

export default Modern_template_2_pdf;